import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";

import PerformanceForm from "./performance-form";
import ET3PageDiv from "../../../core/et3-page-div";
import PerformanceData from "./performance-data";

const CSRSPerformance = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_OTHER_CSR_PERFORMANCE",
      "AUDITOR_OTHER_CSR_PERFORMANCE"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("CSRS_PERFORMANCE")}
        subTitle={i18n.get("CONTROL_PANEL")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />

      <PerformanceForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <PerformanceData />
    </ET3PageDiv>
  );
});
export default CSRSPerformance;
